<div class="ovulation_indeuction header_top mb-5">
    <section class="ovulation_induction_banner">
        <div class="container">
            <div class="banner_content">
                <h6>ICSI & PICSI Treatment</h6>
                <h2 class="visually-hidden">What is ICSI (Intracytoplasmic Sperm Injection)?</h2>
                <h5 class="mb-3">Advanced Fertility Solutions at NCare</h5>
                <p>For couples struggling with male infertility, ICSI (Intracytoplasmic Sperm Injection) and PICSI
                    (Physiological ICSI) offer advanced solutions to improve fertilization and embryo quality. At
                    NCare IVF in Kannur, we provide personalized fertility treatments with advanced technology,
                    ensuring higher success rates for hopeful parents.
                </p>
                <button (click)="contactus()"> Book a Consultation</button>
            </div>
        </div>
    </section>
    <section class="how_does_work_ivf mt-5">
        <div class="container">
            <div class="row aic">

                <div class="col-lg-7 col-md-7 col-sm-12">
                    <h6>What is ICSI (Intracytoplasmic Sperm Injection)? </h6>
                    <p>ICSI is an advanced form of in vitro fertilization (IVF) that helps couples overcome severe
                        male infertility. Unlike conventional IVF, where sperm fertilizes the egg naturally, ICSI
                        involves the precise injection of a single, high-quality sperm directly into the egg. This
                        technique increases fertilization rates, making it ideal for couples with sperm-related issues.
                    </p>
                    <p>We specialize in ICSI treatment to improve embryo quality and maximize pregnancy success
                        rates. Our expert embryologists use cutting-edge micromanipulation technology to ensure
                        optimal results. </p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12">
                    <img loading="lazy"
                        src="../../../../assets/images/treatment/intrauterine_insemination/who_can_benefit_from_ovarian_induction.webp"
                        alt="">
                </div>
            </div>
        </div>
    </section>
    <section class="benefit_ovarian_induction mt-5">
        <div class="title_header tac">Who Needs ICSI?</div>
        <p class="title_para">
            Our specialists assess your fertility profile to determine if ICSI is the best solution <br> for your
            journey to parenthood. ICSI is recommended for couples facing
        </p>
        <div class="container">

            <div class="benefits">
                <div class="card">
                    <h3>Low sperm count (Oligozoospermia)</h3>
                    <p>Insufficient sperm in the semen.</p>
                </div>
                <div class="card">
                    <h3>Poor sperm motility (Asthenozoospermia)</h3>
                    <p>Sperm movement issues affecting fertilization. </p>
                </div>
                <div class="card">
                    <h3>Abnormal sperm shape (Teratozoospermia)</h3>
                    <p>Structural defects reducing sperm function. </p>
                </div>
                <div class="card">
                    <h3>Obstructive azoospermia</h3>
                    <p>No sperm in the semen due to blockages</p>
                </div>

            </div>
        </div>
    </section>
    <section class="how_does_ivf_process_work mt-5">
        <h4 class="title_header tac">
            How Does ICSI Work?
        </h4>
        <p class="title_para">
            ICSI follows a step by step process to ensure successful fertilization and embryo
            development. By using advanced laboratory techniques, this procedure increases the
            chances of conception for couples dealing with male infertility. we ensure high success rates
            through state-of-the-art embryo monitoring and expert fertility care.
        </p>
        <div class="container">
            <div class="row">
                <div class="col-lg-5 col-md-5  col-sm-12 ls" data-step="1">
                    <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_work_1.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12">
                    <h5>
                        Step 1: Ovarian Stimulation & Egg Retrieval
                    </h5>
                    <p>
                        A semen sample is collected from the male partner or retrieved surgically if necessary. The
                        best-quality sperm is selected using advanced sperm processing techniques.
                    </p>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="2">
                    <h5>
                        Step 2: Sperm Collection & Selection
                    </h5>
                    <p>
                        Fertility medications stimulate the ovaries to produce multiple eggs.
                    </p>
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12 ">
                    <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_work_2.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12 ls" data-step="3">
                    <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_work_3.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12">
                    <h5>
                        Step 3: Microinjection of Sperm
                    </h5>
                    <p>
                        Using high-precision micromanipulation technology, a single, healthy sperm is injected
                        directly into the egg to maximize fertilization chances.

                    </p>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="4">
                    <h5>
                        Step 4: Embryo Development & Monitoring
                    </h5>
                    <p>
                        The fertilized eggs develop into embryos over 3 to 5 days, and only the healthiest embryos
                        are selected for transfer.
                    </p>
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12">
                    <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_work_4.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5  col-sm-12 ls" data-step="5">
                    <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_work_5.webp" alt="">
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12">
                    <h5>
                        Step 5: Embryo Transfer & Pregnancy Test
                    </h5>
                    <p>
                        The strongest embryo is transferred into the uterus for implantation. After 12 to 14 days, a
                        pregnancy test confirms the outcome.

                    </p>
                </div>

            </div>
        </div>

    </section>
    <section class="why_choose_ncare_ivf_kannur mt-5">
        <div class="container">
            <h4 class="title_header tac">
                Why Choose NCare IVF for ICSI & PICSI in Kannur?

            </h4>
            <div class="row">
                <span></span>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_picsi_1.svg" alt="">
                        <h5>Advanced Fertility Center</h5>
                        <p>Modern lab facilities for precise sperm selection.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_picsi_2.svg" alt="">
                        <h5> Experienced Andrologists & Embryologists</h5>
                        <p>Specialists in ICSI & PICSI procedures. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_picsi_3.svg" alt="">
                        <h5>High-Quality Sperm Selection Techniques</h5>
                        <p>Enhancing fertilization and embryo quality.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_picsi_4.svg" alt="">
                        <h5> Personalized Fertility Treatment</h5>
                        <p>Focused solutions for male infertility. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="wcnivfk">
                        <img loading="lazy" src="../../../../assets/images/treatment/icsi/icsi_picsi_5.svg" alt="">
                        <h5>Located in Kannur</h5>
                        <p>Accessible world-class reproductive care.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="picsi mt-5">
        <div class="container">
            <h1 class="title_header">PICSI (Physiological ICSI)</h1>
            <p><strong>PICSI (Physiological Intracytoplasmic Sperm Injection)</strong> is an advanced version of ICSI
                designed
                to improve sperm selection for better embryo quality and higher success rates.</p>

            <p>Unlike traditional ICSI, which selects sperm based on movement and shape, PICSI uses a natural selection
                process to identify the most mature and DNA-intact sperm for fertilization. This method enhances the
                chances of
                successful implantation and reduces the risk of genetic abnormalities.</p>

            <h2>Who Should Consider PICSI at NCare IVF, Kannur?</h2>
            <ul>
                <li>Repeated IVF or ICSI failures</li>
                <li>High DNA fragmentation in sperm</li>
                <li>Poor embryo development in previous cycles</li>
                <li>Recurrent miscarriages linked to sperm quality</li>
            </ul>

            <div class="highlight">
                <p>By using <strong>hyaluronan binding technology</strong>, PICSI mimics the natural sperm selection
                    process,
                    ensuring that only the healthiest sperm fertilize the egg. This leads to improved embryo quality,
                    implantation
                    rates, and overall pregnancy success.</p>
            </div>
        </div>
    </section>
    <section class="table mt-5">
        <h4 class="title_header tac">
            Differences Between ICSI & PICSI
        </h4>
        <p class="title_para">
            Our fertility specialists recommend the best option based on your unique fertility profile.
        </p>
        <div class="container">
            <div class="table_sec">
                <table>
                    <thead>
                        <tr>
                            <th>Feature</th>
                            <th>ICSI </th>
                            <th>PICSI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Sperm Selection
                                Method</td>
                            <td>Based on movement &
                                morphology</td>
                            <td>Selected using Hyaluronan binding for
                                better DNA integrity</td>
                        </tr>
                        <tr>
                            <td>Best for</td>
                            <td>Male infertility (low count,
                                motility, shape)</td>
                            <td>Recurrent IVF failure, high DNA
                                fragmentation</td>
                        </tr>
                        <tr>
                            <td>Success Rate</td>
                            <td>High</td>
                            <td>Higher due to superior sperm selection</td>
                        </tr>
                        <tr>
                            <td>Risk of Genetic
                                Damage</td>
                            <td>Slightly higher</td>
                            <td>Lower risk of DNA fragmentation</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
    <section class="pink_bg_content mt-5">
        <div class="container">
            <div class="pink_bg_content_child">
                <h5>Start Your Parenthood Journey with NCare IVF in Kannur </h5>
                <p>At NCare IVF, we offer comprehensive fertility solutions, ensuring the highest standards of
                    care. Whether you need ICSI or PICSI, our experienced specialists will guide you every step
                    of the way</p>
                <button (click)="contactus()">Book a Consultation Today</button>
            </div>
        </div>
    </section>



    <section class="ivf_success_rate mt-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 cool-md-6 col-sm-12">
                    <h6>What is PICSI (Physiological ICSI)?</h6>
                </div>
                <div class="col-lg-6 cool-md-6 col-sm-12">
                    <p>PICSI (Physiological Intracytoplasmic Sperm Injection) is an advanced version of ICSI
                        designed to improve sperm selection for better embryo quality and higher success rates.
                        Unlike traditional ICSI, which selects sperm based on movement and shape, PICSI uses a
                        natural selection process to identify the most mature and DNA-intact sperm for fertilization.
                        This method enhances the chances of successful implantation and reduces the risk of
                        genetic abnormalities. </p>
                </div>
            </div>
        </div>
    </section>
    <section class="what_we_provide mt-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <img loading="lazy" src="../../assets/images/treatment/what_we_provide.webp" alt="">
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h6>Success Rates of ICSI & PICSI at NCare IVF</h6>
                    <ul>
                        <li><span>ICSI Success Rate</span>– 50-60% per cycle for male infertility cases.</li>
                        <li><span>PICSI Success Rate</span> – Higher embryo implantation rates due to enhanced sperm
                            selection.</li>
                    </ul>
                    <p>Our advanced IVF lab in Kannur is equipped with cutting edge micromanipulation and
                        embryo monitoring technology, maximizing success rates. </p>
                </div>
            </div>
        </div>
    </section>

    <section class="faq mt-5">
        <h4 class="title_header tac">
            Frequently Asked Questions
        </h4>
        <div class="container">
            <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Is ICSI more successful than regular IVF?

                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            Yes. ICSI is more effective for male infertility cases, as it directly injects a healthy
                            sperm into
                            the egg, increasing fertilization chances.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            How is PICSI different from ICSI?
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            PICSI is an enhanced version of ICSI that selects only the healthiest sperm using
                            hyaluronan binding, leading to better embryo quality and higher pregnancy success.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            Does ICSI increase the risk of birth defects?
                        </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            The risk is very low and comparable to natural conception. At NCare IVF in Kannur, we
                            follow strict quality control measures to ensure the healthiest embryos are used.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            Can ICSI or PICSI help with repeated IVF failures?
                        </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            Yes. PICSI is particularly beneficial for couples who have had failed IVF/ICSI cycles due to
                            poor embryo quality or implantation issues.
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                            How many ICSI cycles are needed for success?
                        </button>
                    </h2>
                    <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            Success depends on individual fertility factors. Many couples conceive within 1-3 ICSI
                            cycles, but some may need additional cycles for success.
                        </div>
                    </div>
                </div>
            </div>
            <button class="contact_us_info" (click)="contactus()">Contact Us for more information</button>
        </div>
    </section>

</div>